import { render, staticRenderFns } from "./OAuthReturn.vue?vue&type=template&id=e39297fe&"
import script from "./OAuthReturn.vue?vue&type=script&lang=js&"
export * from "./OAuthReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports